import { gql } from '@biletiniz/apollo';

export const SIGNUP = gql`
  mutation register (
    $name: String!,
    $surname: String!,
    $email: String!,
    $password: String!,
    $phoneNumber: String!,
    $verifyPhone: Boolean! ) {
    register(
      name: $name,
      surname: $surname,
      email: $email,
      password: $password,
      phoneNumber:$phoneNumber,
      verifyPhone:$verifyPhone,
    ) {
      message
      session
    }
  }
`;
